import React from "react";
import "../styles/HowItWorks.css";
import trackIcon from "../asserts/track.png";
import analyzeIcon from "../asserts/analyze.png";
import coachIcon from "../asserts/coach.png";
import processing from "../asserts/processing.png";
import tracking from "../asserts/tracking.png";
import Accessible from "../asserts/Accessible.png";
import visual from "../asserts/visual.png";
import mic from "../asserts/mic.png";

const HowItWorks = () => {
  return (
    <section className="how-section">
      <h1 className="bg-title">The Technology</h1>

      <div className="how-header">
        <h2>How it works?</h2>
        <p>
          GYDE works on our proprietary AI coaching pipeline that converts
          movement into personalized
          <br />
          coaching in three intelligent stages.
        </p>
      </div>

      <div className="work-cards">
        <div className="work-card">
          <div className="card-header">
            <img src={trackIcon} alt="track" className="card-icon" />
            <h3>TRACK</h3>
          </div>

          <p>
            Capture and understand human movement using standard camera and
            AI-Motion body pose estimation using{" "}
            <span>33+ critical body key points</span> and gesture recognition.
          </p>
        </div>

        <div className="work-card">
          <div className="card-header">
            <img src={analyzeIcon} alt="analyze" className="card-icon" />
            <h3>ALALYZE</h3>
          </div>

          <p>
            Our AI Engine builds a digital model of the movement, interpreting
            joint relationships, and movement patterns against performance
            metrics —
            <span>
              {" "}
              replicating the observational process of an expert coach.
            </span>
          </p>
        </div>

        <div className="work-card">
          <div className="card-header">
            <img src={coachIcon} alt="coach" className="card-icon" />
            <h3>COACH</h3>
          </div>

          <p>
            Our Expert Coaching Engine translates the insights into personalized
            live
            <span> audio-visual guidance</span>, performance reviews, corrective
            recommendations, insights for coaches, & long-term progress
            insights.
          </p>
        </div>
      </div>

      <div className="coaching">
        <h2>One-to-one coaching democratized !</h2>
        <p>
          Experience expert movement coaching—anytime, anywhere, using just your
          smartphone.
        </p>
      </div>

      <div className="features">
        <div>
          <img src={processing} />
          <h4>Real-time processing</h4>
          <p>Seamless experience with real time movement processing</p>
        </div>

        <div>
          <img src={mic} />
          <h4>Audio feedback</h4>
          <p>Real-Time Audio guidance and feedback</p>
        </div>

        <div>
          <img src={visual} />
          <h4>Visual feedback</h4>
          <p>Side-by-side comparisons & breakdowns</p>
        </div>

        <div>
          <img src={Accessible} />
          <h4>Accessible anywhere</h4>
          <p>Runs on standard Mobile camera</p>
        </div>

        <div>
          <img src={tracking} />
          <h4>Long term Tracking</h4>
          <p>Accurate data-driven progress tracking</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
